function StatusPage(props) {
    const { msg } = props;

    return (
        <div class='status-page-content'>
            <label class='status-page-content-text'>{ `${msg}` }</label>
        </div>
    );

};


export default StatusPage;